import { render, staticRenderFns } from "./u-icon.vue?vue&type=template&id=83fe9326&scoped=true&"
import script from "./u-icon.vue?vue&type=script&lang=js&"
export * from "./u-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fe9326",
  null
  
)

export default component.exports